<section class="docs-page">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="mt-4 mb-4">
                    <h1>Privacy Policy</h1>
                    <p>Strait Air Transport is committed to protecting your privacy. This policy describes 
                    our practices regarding information collected through our Website. In order to use 
                    this Website you may be required to registered or create an account. During 
                    registration you may be required to give contact information. You will be required 
                    to provide "personal and account information" which means your name, company name, 
                    address, telephone number, and email address plus any other information that 
                    identifies you, and would permit us to contact you. When we use the terms 
                    "Strait Air" "we" and "us" this means Strait Air Transport A/S, Scan-Group A/S, 
                    as well as, all affiliated companies. Scan-Group is the sole owner of www.straitair.com 
                    and www.scan-group.com. Strait Air Transport collects personally identifiable information 
                    from our users at several different points on our Website.
                    </p>
                </div>

                <div class="mb-4">
                    <h4>When you browse our Website we collect certain types of information</h4>
                    <ul class="ps-3">
                        <li>IP address: We collect your IP address to measure our Website traffic.</li>
                        <li>Browser type: We collect information about the browser you are using to help optimize our Website for visitors.</li>
                        <li>Movements through our Website: We keep track of pages you visit to help provide you with a more personalized service.</li>
                    </ul>
                </div>

                <div class="mb-4">
                    <h4>When you access the Strait Air Transport e-commerce portal on our Website</h4>
                    <p>We collect your user name, password, email address, to protect your identity. You can help us ensure your privacy by not sharing your username or password.</p>
                </div>

                <div class="mb-4">
                    <h4>Profile</h4>
                    <p>We store information that we collect through session Ids and log files to create a "profile" of your preferences. We tie your personally identifiable information, 
                        to information in the profile, in order to provide tailored service to address you needs.
                        <br><strong>Restricted Access to Your Information:</strong><br>
                        We restrict access to your information to those who need access to use it as set forth in this policy. If you are asked to set up a user profile to access the Strait 
                        Air Transport website you may be required to set up a password.  Any password that you establish on 
                        the Strait Air Transport website is encrypted so that Strait Air Transport does not have access to 
                        your password. Your other account information may be disclosed to third parties in limited 
                        circumstances. For example, we may share your personal and account information with our service 
                        providers and strategic partners and with suppliers and other entities involved in transactions you 
                        have initiated. We may disclose your personal and account information to respond to subpoenas, court
                        orders, or other legal process, as required by law, or to establish or exercise our legal rights or 
                        defend against legal claims.
                    
                    </p>
                </div>

                <div class="mb-4">
                    
                </div>

                <div class="mb-4">
                    <h3>Supplementation of Information</h3>
                    <p>In order to provide certain services to you, we may on occasion supplement the personal information you submitted to us 
                        with information from third party sources, such as credit reporting agencies, commercial credit bureaus and business 
                        reporting services.
                    </p>
                </div>

                <div class="mb-4">
                    <h3>Personally identifiable information</h3>
                    <p>We do not share personally identifiable information with third parties</p>
                </div>

                <div class="mb-4">
                    <h3>Legal Disclaimer</h3>
                    <p>We reserve the right to disclose your personally identifiable information as required by law and when we believe that disclosure 
                        is necessary to protect our rights and/or to comply with a judicial proceeding, court order, or legal process served on us.
                    </p>
                </div>

                <div class="mb-4">
                    <h3>Log Files</h3>
                    <p>As is true of most Websites, we gather certain information automatically and store it in log files. This information includes internet 
                        protocol (IP) addresses, browser type, internet service provider (ISP), referring/exit pages, operating system, date/time stamp.
                        <br><br>
                        We use this information, which does not identify individual users, to analyze trends, to administer the site, to track users' 
                        movements around the site and to gather demographic information about our user base as a whole.
                        <br><br>
                        We do link this automatically-collected data to personally identifiable information. IP addresses 
                        are tied to personally identifiable information to better enable us to provide efficient service to 
                        our customers.
                    </p>
                </div>

                <div class="mb-4">
                    <h3>Questions, Problems and Complaints</h3>
                    <p>If you have a question about this policy statement, or a complaint about Strait Air Transport compliance with this privacy policy,
                         you may contact Strait Air Transport by e-mail at <a href="#" style="color: #fc7c00;"><strong>dataprotection&#64;straitair.com</strong></a>.
                    </p>
                </div>
            </div>
        </div>
    </div>
</section>


<app-sat></app-sat>
<router-outlet></router-outlet>